import Card from "./Card";
import ChipField from "../components/fields/ChipField";
import EditButton from "../components/buttons/EditButton";
import Filters from "./Filters";
import React from "react";
import ResponsiveGridWithWebsocket from "../components/list/ResponsiveGridWithWebsocket";
import ResponsiveList from "../components/list/ResponsiveList";
import SensorValueField from "../components/fields/SensorValueField";
import StatusField from "./fields/StatusField";
import { TextField } from "react-admin";
import { useRowHighlightTracking } from "../components/utils/useRowHighlightTracking";

const List = (props) => {
  const { sensor: highlightedSensorIds = [] } = useRowHighlightTracking();

  const rowClass = (record) => {
    const id = record.id?.toString();
    if (highlightedSensorIds.includes(id)) return "modifySensor";
    return "";
  };

  return (
    <ResponsiveList
      {...props}
      exporter={false}
      filters={<Filters />}
      filterDefaultValues={{
        equipment_enum: "all",
        is_assigned: true,
      }}
      type="table"
      split
      key={highlightedSensorIds.join(",")}
    >
      <ResponsiveGridWithWebsocket
        target="sensor"
        rowBreakpoint="sm"
        cardContent={<Card />}
        rowClasses={rowClass}
      >
        <TextField source="id" />
        <TextField source="device.code" />
        <ChipField source="code" color="primary" />
        <TextField source="name" />
        <StatusField sortable={false} />
        <SensorValueField />
        <EditButton />
      </ResponsiveGridWithWebsocket>
    </ResponsiveList>
  );
};

export default List;
